export const EXPORT_TEMPLATE_MAX_LIMIT = 256;
export const EXPORT_TEMPLATE_MAX_LIMIT_FOR_INTEGRATION = 47;
export const TEMPLATE_CATEGORY_DATA_ATTRIBUTE_KEY = 'data-template-category';
